import { render, staticRenderFns } from "./TrainPage.vue?vue&type=template&id=27108d14&scoped=true"
import script from "./TrainPage.vue?vue&type=script&lang=js"
export * from "./TrainPage.vue?vue&type=script&lang=js"
import style0 from "./TrainPage.vue?vue&type=style&index=0&id=27108d14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27108d14",
  null
  
)

export default component.exports